import dayjs from 'dayjs';

import type { TimePeriod } from 'app/components/pages/Extranet/ExtranetInventory/Legacy/type';
import { getDatesToFill } from 'app/components/pages/Extranet/ExtranetInventory/Legacy/utils';

import type { DuplicationModeData } from '../../../DuplicationMenu/DuplicationMenu';
import { DuplicationMode } from '../../../DuplicationMenu/DuplicationMenu';

export const onHover = (
  day: dayjs.Dayjs,
  mode: DuplicationModeData,
  timePeriod: TimePeriod,
  setDuplicationDateSelection: (dates: string[]) => void
) => {
  const timePeriodFormatted = {
    startDate: dayjs(timePeriod.startDate).toDate(),
    endDate: dayjs(timePeriod.endDate).toDate(),
  };

  const interval = getDatesToFill(
    day.toDate(),
    mode.mode === DuplicationMode.CUSTOM
      ? { ...mode, customDay: mode.customDay.toDate() }
      : mode,
    timePeriodFormatted
  );

  const rangeWithoutCurrentDay = {
    start: dayjs(interval.start).add(1, 'day').toDate(),
    end: interval.end,
  };

  const start = dayjs(rangeWithoutCurrentDay.start).startOf('day');
  const end = dayjs(rangeWithoutCurrentDay.end).startOf('day');
  const diffDays = end.diff(start, 'day');

  const daysInRange = Array.from({ length: diffDays + 1 }, (_, i) =>
    start.add(i, 'day')
  );

  setDuplicationDateSelection(daysInRange.map((d) => d.format('YYYY-MM-DD')));
};
